export default {
    methods: { 
        toggle: function (data) {
            if (this.show_contents.indexOf(data) >= 0) {
                this.show_contents = this.show_contents.filter(n => n !== data)
            }else {
                this.show_contents.push(data)
            }
        }
    },
    computed: {
        currentTabComponent() {
            return 'tab-' + this.currentTab.toLowerCase()
        }
    },
}